<div class="order-logs">
  <h5 class="order-logs__title">Order logs</h5>
  <div class="order-logs__items">
    @if (!logs.length) {
      <span>-</span>
    }

    @for (log of logs; track log) {
      <div class="order-log">
        <span class="order-log__date">{{ log.date }}</span>
        <span class="order-log__text"> {{ log.log }}</span>
      </div>
    }
  </div>
</div>
